import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "text-sm" }
const _hoisted_2 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_3 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_4 = {
  key: 2,
  class: "text-sm"
}
const _hoisted_5 = {
  key: 3,
  class: "text-sm"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("—")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.entry.payout_method)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.PAYOUT_METHODS_MAP[_ctx.entry.payout_method].label), 1),
        (_ctx.isCrypto)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.entry.payout_method_crypto_wallet_address || '—'), 1))
          : _createCommentVNode("", true),
        (_ctx.entry.payout_method === _ctx.PAYOUT_METHOD_PAYONEER)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.entry.payout_method_payoneer_email || '—'), 1))
          : _createCommentVNode("", true),
        (_ctx.entry.payout_method === _ctx.PAYOUT_METHOD_PAYPAL)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.entry.payout_method_paypal_email || '—'), 1))
          : _createCommentVNode("", true),
        (_ctx.entry.payout_method === _ctx.PAYOUT_METHOD_WEBMONEY)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.entry.payout_method_webmoney_wallet || '—'), 1))
          : _createCommentVNode("", true)
      ], 64))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _hoisted_6
      ], 64))
}